<template>
  <TitlePage
    class="page-edit-user-desc"
    :title="lang.title"
    @back="$emit('back')"
    @commit="commit"
  >
    <div class="page-edit-user-desc-desc">
      <textarea class="page-edit-user-desc-desc-textarea" v-model="input.profile" :placeholder="lang.input.profile" />
    </div>
  </TitlePage>
</template>

<script>
import _ from 'lodash'
import TitlePage from './TitlePage.vue'
export default {
  components: {
    TitlePage
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    lang: {
      type: Object,
      default () {
        return {
          title: '编辑个人简介',
          input: {
            profile: '请描述您的职业历程'
          }
        }
      }
    }
  },
  data () {
    return {
      input: {
        profile: _.get(this.data, 'card.profile')
      }
    }
  },
  methods: {
    close () { this.$emit('close') },
    commit () { this.$emit('commit', this.input) }
  }
}
</script>

<style lang="postcss" scoped>
@import "index.css";
.page-edit-user-desc {
  overflow: hidden;
  & .page-edit-user-desc-desc {
    & .page-edit-user-desc-desc-textarea {
      position: relative;
      display: block;
      margin: 24px auto;
      padding: 15px 20px;
      width: 75%;
      height: calc(500px / var(--scale));
      border: 1px solid var(--colorDisabled);
      outline: none;
      font-size: var(--textSize3);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/EditUserDescPage.vue